import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()({
    iframe: {
        minHeight: 850,
        width: "100%",
        border: "none",
    },
});
